import {apiFetch} from "./client";
import type {SecondFactorStatus} from "./admin/secondFactor";

// ─── Свой двухфакторный вход (мерчант, трейдер) ───────────────
// Источник правды по телам: internal/sso/second_factor_self.go + oapi-spec.yml.
// Включение в два шага: ожидающий ключ (QR), затем код из приложения. Пока
// код не введён, вход прежний; ключ не хранится на клиенте.

/** Сколько минут живёт ожидающий ключ, если его не подтвердили. */
export const OWN_SECOND_FACTOR_ENROLLMENT_MINUTES = 10;

/** Ожидающий ключ: показать один раз, подтвердить кодом. */
export interface OwnSecondFactorEnrollment {
    login: string;
    secret: string;
    otpauthUri: string;
    /** PNG QR-кода как data URL. */
    qrCode: string;
    expiresAt: string;
}

/** Своя 2FA: плюс срок начатого, но не подтверждённого включения. */
export interface OwnSecondFactorStatus extends SecondFactorStatus {
    /** Есть, пока ожидающий ключ действует; сам ключ повторно не приходит. */
    enrollmentExpiresAt?: string;
}

/** GET /v1/me/second-factor — включена ли 2FA у себя и ждёт ли кода начатое включение. */
export function getOwnSecondFactor(token: string | null): Promise<OwnSecondFactorStatus> {
    return apiFetch<OwnSecondFactorStatus>("/me/second-factor", token);
}

/** POST /v1/me/second-factor/enrollment — новый ожидающий ключ; прежний ожидающий гаснет. */
export function startOwnSecondFactor(token: string | null): Promise<OwnSecondFactorEnrollment> {
    return apiFetch<OwnSecondFactorEnrollment>("/me/second-factor/enrollment", token, {method: "POST"});
}

/** POST /v1/me/second-factor/enrollment/confirm — код из приложения включает 2FA; другие сессии закрываются. */
export function confirmOwnSecondFactor(token: string | null, code: string): Promise<SecondFactorStatus> {
    return apiFetch<SecondFactorStatus>("/me/second-factor/enrollment/confirm", token, {
        method: "POST",
        body: JSON.stringify({code}),
    });
}

/** POST /v1/me/second-factor/disable — текущий код из приложения выключает 2FA. */
export function disableOwnSecondFactor(token: string | null, code: string): Promise<SecondFactorStatus> {
    return apiFetch<SecondFactorStatus>("/me/second-factor/disable", token, {
        method: "POST",
        body: JSON.stringify({code}),
    });
}
